import { Heading } from "@radix-ui/themes";
import { usePage } from "@inertiajs/react";
import AppTheme from "@/layouts/AppTheme";
import { type ReactNode } from "react";
import type { SharedProps } from "@/types";

// Onboarding steps opt out of the app's top bar and sidebar: one question at a
// time, nothing else to click but Back, Skip and Continue. The wordmark is the
// site's: the brand's name on a branded site, DRIFTABLES otherwise.
export default function OnboardingLayout({
  children,
}: {
  children: ReactNode;
}) {
  const { brand } = usePage<SharedProps>().props;

  return (
    <AppTheme>
      <div className="flex min-h-screen flex-col items-center bg-canvas px-4 pb-16 pt-8">
        <Heading size="4" className="mb-8 text-accent9">
          {brand?.name?.toUpperCase() ?? "DRIFTABLES"}
        </Heading>
        <div className="w-full max-w-2xl">{children}</div>
      </div>
    </AppTheme>
  );
}

export const onboardingLayout = (page: ReactNode) => (
  <OnboardingLayout>{page}</OnboardingLayout>
);
